import { Text, Flex, Image } from '@chakra-ui/react';

import notifySuccess from 'assets/svg/notify-success.svg';

import Card from 'components/Card/Card';

export default function Success (props) {
  return (
    <>
    	<Card 
          bg="rgba(0, 255, 8, 0.3)"
          borderRadius="16px"
          maxW={props.maxW ?? '100%'}
          variant="ghost" 
          padding='24px 16px' 
          mb={{ sm: '8px' }}>
          <Flex>
            <Image src={notifySuccess} h="24px"/>
              <Text ml="16px" maxW={{ sm: '100%', md: '70%' }} mt="2px" variant="text-md">
                  {Array.isArray(props.message)
                      ? `Success: ${props.message.join(', ')}`
                      : typeof props.message === 'string'
                          ? `Success: ${props.message}`
                          : 'Success!'}
              </Text>
          </Flex>
        </Card>
    </>
  );
}